// 等级：0-黑铁、1-青铜、2-白银、3-黄金、4-铂金、5-黑金、6-钻石V1、7-钻石V2、8-钻石V3、9-钻石V4
// 通用表情包
const CommonExpressionList = [
  '微笑',
  '撇嘴',
  '色',
  '得意',
  '流泪',
  '害羞',
  '睡',
  '大哭',
  '尴尬',
  '生气',
  '调皮',
  '呲牙',
  '惊讶',
  '难过',
  '酷',
  '冷汗',
  '淘气',
  '吐',
  '偷笑',
  '可爱',
  '白眼',
  '傲慢',
  '舔',
  '困',
  '惊恐',
  '汗',
  '大笑',
  '奋斗',
  '咒骂',
  '疑问',
  '嘘',
  '晕',
  '敲打',
  '拜拜',
  '擦汗',
  '抠鼻',
  '高兴',
  '糗大了',
  '窃笑',
  '左哼哼',
  '右哼哼',
  '哈欠',
  '鄙视',
  '委屈',
  '快哭了',
  '阴险',
  '亲亲',
  '可怜',
  '菜刀',
  '吃饭',
  '猪头',
  '吻',
  '爱心',
  '心碎',
  '便便',
  '月亮',
  '拥抱',
  '给力',
  '不给力',
  '握手',
  '胜利',
  '抱拳',
  '勾引',
  '拳头',
  '差劲',
  '爱你',
  'NO',
  'OK',
  '凋谢',
  '发呆',
  '大兵',
  '太阳',
  '炸弹',
  '玫瑰',
  '礼物',
  '蛋糕',
  '衰',
  '闭嘴',
  '骷髅',
  '干杯',
];

// 黄金等级及其以上可用表情包

const Level3ExpressionList = [
  '扮酷',
  '擦汗',
  '财迷',
  '超人',
  '聪明',
  '大哭',
  '大笑',
  '发怒',
  '鼓掌',
  '坏笑',
  '惊讶',
  '鞠躬',
  '可怜',
  '渴望',
  '劳累',
  '卖萌',
  '美人',
  '亲密',
  '亲亲',
  '失望',
  '睡觉',
  '思考',
  '跳舞',
  '吐舌头',
  '微笑',
  '我错了',
  '羞涩',
  '疑问',
  '晕',
  '钟爱',
  '撞墙',
  '抽耳光',
  '摸头',
  '群舞',
  '握手',
  '强吻',
];
// 铂金等级及其以上可用表情包

const Level4ExpressionList = [
  '暗中观察',
  '抱抱',
  '比心',
  '财迷',
  '吃瓜',
  '嗨起来',
  '花花',
  '酷',
  '摸摸头',
  '你好',
  '亲亲',
  '生日快乐',
  '再见',
  '赞',
  '扎心',
  '猪头',
];

// 黑金等级及其以上可用表情包

const Level5ExpressionList = [
  '亲吻屏幕',
  '买买买',
  '中毒',
  'ok',
  '偷听',
  '冒汗',
  '发火',
  '吃东西',
  '吃药',
  '吐舌头',
  '可怜',
  '吐血',
  '吵架',
  '吓宝宝',
  '呕吐',
  '哭笑',
  '大哭',
  '困',
  '委屈哭',
  '寂寞',
  '头晕',
  '心眼',
  '恐怖',
  '惊吓红嘴',
  '恶心',
  '打电话',
  '戴墨镜',
  '抠鼻子',
  '招手',
  '捂嘴笑',
  '摸胡子',
  '杀气',
  '流口水',
  '流鼻血',
  '烧焦',
  '生气',
  '中指',
  '疑惑',
  '砸蛋',
  '石化',
  '约吗',
  '耶',
  '肥皂',
  '色迷迷',
  '苦瓜脸',
  '要脸不',
  '通便器',
  '鄙视',
  '闭嘴',
  '露牙肉',
  '馋了',
  '鼓掌',
];

// 钻石V1等级及其以上可用表情包

const Level6ExpressionList = [
  '666',
  '暗中观察',
  '抱抱',
  '吃瓜',
  '嗨起来',
  '妙呀',
  '牛啤',
  '生日快乐',
  '栓Q',
  '送花',
  '我来咯',
  '心动',
  '再见',
  '扎心',
  'mua',
  'YYDS',
];

// 钻石V3等级及其以上可用表情包
const Level8ExpressionList = [
  '暗中观察',
  '抱抱',
  '比心',
  '财迷',
  '吃瓜',
  '打call',
  '嗨起来',
  '摸摸头',
  '你好',
  '亲亲',
  '送花花',
  '疑问',
  '再见',
  '赞',
  '扎心',
  '猪头',
];

const ExpressionConfigs = [
  {
    name: 'common',
    desc: '',
    icon: 'https://lib.sumeme.com/base/styles/expression/common/微笑.gif',
    level: 0,
    limitTip: '',
    directSend: false,
    className: 'expression-img-sm',
    content: {
      list: CommonExpressionList,
      prefix: '/',
      postfix: '.gif',
      directory: 'base/styles/expression/common/',
      size: {
        width: 30,
        height: 30,
      },
    },
  },
  {
    name: 'level4',
    desc: '铂金',
    icon: 'https://img-photo.sumeme.com/2/2/1678672616578_8651_8651.png?v=1678672616578',
    level: 4,
    limitTip: '达成「铂金」会员等级，即可使用当前表情',
    directSend: true,
    content: {
      list: Level4ExpressionList,
      prefix: '/v',
      postfix: '.gif',
      directory: 'base/styles/expression/level4/',
      size: {
        width: 36,
        height: 36,
      },
    },
  },
  {
    name: 'level6',
    desc: '钻石V1',
    icon: 'https://img-photo.sumeme.com/50/2/1678672617522_6056_6056.png?v=1678672617523',
    level: 6,
    limitTip: '达成「钻石V1」会员等级，即可使用当前表情',
    directSend: true,
    content: {
      list: Level6ExpressionList,
      prefix: '/m',
      postfix: '.gif',
      directory: 'base/styles/expression/level6/',
      size: {
        width: 80,
        height: 36,
      },
    },
  },
  {
    name: 'level8',
    desc: '钻石V3',
    icon: 'https://img-photo.sumeme.com/11/3/1678672618379_6376_6376.png?v=1678672618379',
    level: 8,
    limitTip: '达成「钻石V3」会员等级，即可使用当前表情',
    directSend: true,
    content: {
      list: Level8ExpressionList,
      prefix: '/l',
      postfix: '.gif',
      directory: 'base/styles/expression/level8/',
      size: {
        width: 36,
        height: 36,
      },
    },
  },
  // {
  //   name: 'level9',
  //   desc: '钻石V4',
  //   icon: 'https://lib.sumeme.com/base/styles/expression/common/酷.gif',
  //   level: 9,
  //   limitTip: '达成「钻石V4」会员等级，即可使用当前表情',
  //   directSend: false,
  //   content: {
  //     list: Level9ExpressionList,
  //     prefix: '/s',
  //     postfix: '.png',
  //     directory: 'base/styles/expression/privilege/',
  //     size: {
  //       width: 72,
  //       height: 72,
  //     },
  //   },
  // },
];

export { ExpressionConfigs };
